<template>
    <div class="pt-5">
        <div v-if="!errorResponse" class="container">
            <div class="py-3">
                <a @click="generatePDF" class="btn btn-primary float-right">Download PDF</a>
            </div>
            <div ref="invoiceElement" class="container">
                <div class="text-center" v-if="orderToShow">
                    <h2 class="text-danger" v-if="orderToShow.status === 0">
                        <i class="bi bi-exclamation-diamond"></i>
                        <span>
                            Not Cleared
                        </span>
                    </h2>
                    <h2 class="text-success" v-else>
                        <i class="bi bi-check2-circle"></i>
                        <span>
                            PAID
                        </span>
                    </h2>
                    <hr />
                </div>
                <div class="text-left">
                    <div v-if="companyDetails">
                        <div v-if="companyDetails !== '' && showLogo" class="text-center company-logo-wrap">
            <img
              v-if="companyDetails.logo_url && !logoFailed"
              class="centered company-logo"
              :src="proxiedLogoUrl"
              alt="Company logo"
              @error="logoFailed = true"
            />

          </div>
          <p class="centered text-center" v-if="companyDetails !== ''">
            <span class="compan-details">{{ companyDetails.name }}</span>
            <span v-if="companyDetails.companysettings && companyDetails.companysettings.document_tagline"><br /><strong><em>{{ companyDetails.companysettings.document_tagline }}</em></strong></span>
            <span v-if="companyDetails.companysettings && companyDetails.companysettings.document_description"><br /><small>{{ companyDetails.companysettings.document_description }}</small></span>
            <span v-if="companyDetails.phone !== null"><br />Phone: {{ companyDetails.phone }}</span>
            <span v-if="companyDetails.email !== null"><br />Email: {{ companyDetails.email }}</span>
            <span v-if="companyDetails.address !== null"><br />Address: {{ companyDetails.address }}</span>
            <span v-if="companyDetails.building !== null"><br />Location: {{ companyDetails.building }}</span
            ><span v-if="companyDetails.street !== ''">{{ companyDetails.street }}</span>
            <span v-if="companyDetails.town !== null"><br />Town: {{ companyDetails.town }}</span>
            <span v-if="companyDetails.krapin !== null"><br />PIN: {{ companyDetails.krapin }}</span>
          </p>
          <hr class="my-1" />
                </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="text-left" v-if="customer">
                            <h2 class="py-2">Bill to:</h2>
                            <p v-if="customer" class="py-1">Customer:&nbsp; <span class="font-weight-bold"></span>&nbsp;{{ customer.full_name }} </p>
                            <p v-if="customer.phone" class="py-1">Customer phone:&nbsp; <span class="font-weight-bold"></span>&nbsp;{{ customer.phone }} </p>
                            <p v-if="customer.email" class="py-1">Customer email:&nbsp; <span class="font-weight-bold"></span>&nbsp;{{ customer.email }} </p>
                            <p v-if="customer.company" class="py-1">Company:&nbsp;{{ customer.company }} </p>
                            <p v-if="customer.krapin" class="py-1">KRA PIN:&nbsp;{{ customer.krapin }} </p>
                            <p v-if="customer.full_address" class="py-1">Address:&nbsp;{{ customer.full_address }} </p>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="text-right">
                            <h2 class="py-2">Order Details:</h2>
                            <h6>Order No: &nbsp; {{ orderToShow.order }}</h6>
                            <p class="py-1">Time:&nbsp; <span class="text-capitalize">{{ formatDate(orderToShow.created_at,'hh:mm A') }}</span>
                            </p>
                            <p class="py-1">Date:&nbsp; <span class="text-capitalize">{{ formatDate(orderToShow.created_at,'DD-MMM-YYYY') }}</span>
                            </p>
                            <p class="py-1">Served By:&nbsp; <span class="text-capitalize">{{ orderToShow.soldby?.name || 'N/A' }}</span></p>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="text-left">
                    <h5>
                        Product order list
                    </h5>
                </div>
                <table class="table table-hover">
                    <thead :style="{ backgroundColor: accentColor, color: '#fff' }">
                        <td>#</td>
                        <td>Item</td>
                        <td>Unit</td>
                        <td>SP/UNIT</td>
                        <td>Qty</td>
                        <td>Amount</td>
                    </thead>
                    <tbody>
                        <tr v-for="(orderItem,index) in orderToShow.orders">
                            <td>
                                <h6>{{ index + 1 }}</h6>
                            </td>
                            <td>

                                <h6>{{orderItem.product ? orderItem.product.product: (orderItem.grouped_inventory) ? orderItem.grouped_inventory.group_title:'' }}</h6>
                            </td>
                            <td>
                                <h6>{{orderItem.product ? orderItem.product.measuring_unit: '' }}</h6>

                            </td>
                            <td>
                                <h6>{{ convertCurrencyToShillings(orderItem.selling_price) }}</h6>
                            </td>
                            <td>
                                <h6>{{ orderItem.qty }}</h6>
                            </td>
                            <td v-if="orderItem.is_retail === 1">
                                <h6>{{convertCurrencyToShillings( orderItem.product ? orderItem.qty * ((orderItem.selling_price !== null ) ? orderItem.selling_price : orderItem.product.ppu) :  (orderItem.grouped_inventory) ? orderItem.qty * orderItem.grouped_inventory.cost : 0)}}</h6>
                            </td>
                            <td v-else-if="orderItem.is_retail === 0">
                                <h6>{{convertCurrencyToShillings( orderItem.product ? orderItem.qty * ((orderItem.selling_price !== null ) ? orderItem.selling_price : orderItem.product.wholesale_sp) :  (orderItem.grouped_inventory) ? orderItem.qty * orderItem.grouped_inventory.wholesale : 0)}}</h6>
                        </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table table-hover">
                    <tbody>
                        <tr>
                            <td class="text-left">
                                <h6 class="py-1"> All Item/Services</h6>
                            </td>
                            <td class="text-right">
                                <h5 class="py-1 text-dark"> {{ totalQuantity }}</h5>
                            </td>
                        </tr>
                        <tr v-if="orderToShow.discount !==null">
                            <td class="text-left">
                                <h6 class="py-1"> Discount</h6>
                            </td>
                            <td class="text-right">
                                <h5 class="py-1 text-dark">{{ convertCurrencyToLocal(orderToShow.discount) }}</h5>
                            </td>
                        </tr>
                        <tr v-if="orderToShow.partial && orderToShow.balance > 0">
                            <td class="text-left">
                                <h6 class="py-1"> Balance</h6>
                            </td>
                            <td class="text-right">
                                <h5 class="py-1 text-success">{{ convertCurrencyToLocal(orderToShow.balance) }}</h5>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-left">
                                <h5 class="py-1">Grand Total</h5>
                            </td>
                            <td class="text-right">
                                <h5 class="py-1 text-primary font-weight-bold">{{ convertCurrencyToLocal(orderToShow.total_amount) }}</h5>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="text-center">
                    <div v-html="companyDetails.configs">

                </div>
                </div>
                <hr />
                <div v-if="orderToShow && orderToShow.ordernotes" class="text-left">
                    <h5 class="py-1">Notes:</h5>
                    <div v-for="note in orderToShow.ordernotes">
                        <div v-if="note.on_receipt">
                            <p style="white-space: pre-line;">{{ note.note }}</p>
                        </div>
                    </div>

                    </div>

                <hr />
                <div class="text-right">
                    <p v-if="orderToShow.status === 1 && orderToShow.partial === 0" class="py-1 font-weight-bold">Payment:&nbsp; <span class="text-capitalize">{{ orderToShow.paymentmethod ? orderToShow.paymentmethod.payment_method : 'Unknown' }}</span></p>
                    <p v-else-if="orderToShow.status === 1 && orderToShow.partial === 1" class="py-1 font-weight-bold">
                        Payments:&nbsp;
                        <span v-if="orderToShow.splitorderpayment.length > 0" class="text-capitalize">
                            <ul>
                                <li  v-for="splitPayment in orderToShow.splitorderpayment">
                                    {{ splitPayment.paymentmethod ? splitPayment.paymentmethod.payment_method : 'Unknown' }} -
                                {{ convertCurrencyToShillings(splitPayment.paid_amount) }}
                                </li>
                            </ul>

                        </span>
                    </p>
                </div>
                <div v-if="companyDetails.companysettings" class="text-center">
                   <div v-if="companyDetails.companysettings.configs" v-html="companyDetails.companysettings.configs"></div>
                   <div v-if="companyDetails.companysettings.receipt_footer_message" v-html="companyDetails.companysettings.receipt_footer_message"></div>

                </div>
                <div class="mb-5 text-center">
                    <a class="powered-by-dukakit" :href="$platformBrand.websiteUrl" target="_blank" rel="noopener">
                        <span>Powered by</span>
                        <img :src="$platformBrand.logoUrl" :alt="$platformBrand.name" />
                    </a>
                </div>
            </div>
        </div>
        <div v-else>

            <div class="container justify-content-center">
                <h2 class="text-center text-danger">We are sorry we couldn't find your order</h2>
                <hr/>
                <br/>

                <p class="text-center"> Visit/call and request for order search with keyword:<span class="text-bold">{{ errorResponse }}</span></p>
            </div>

        </div>
    </div>
</template>

<script>
    import html2pdf from 'html2pdf.js'; // Import the html2pdf library
    export default {
        props: ['orderNumberUrl'],
        data() {
            return {
                orderToShow: {
                    soldby: {},
                },
                customer: {},
                orderItems: {},
                companyDetails: {},
                totalQuantity: 0,
                errorResponse:'',
                logoFailed: false,
            }
        },
        computed: {
            showLogo() {
                const settings = this.companyDetails && this.companyDetails.companysettings;
                return !settings || settings.document_show_logo !== false;
            },
            accentColor() {
                const settings = this.companyDetails && this.companyDetails.companysettings;
                return (settings && settings.document_accent_color) || '#55595f';
            },
            // The PDF export (generatePDF, below) snapshots this page via
            // html2canvas, which can't read pixel data from a cross-origin
            // image (the logo is hosted on R2, a different origin) unless
            // it's same-origin — hence proxying it through our own domain,
            // same fix as invoice.vue uses for the same reason.
            proxiedLogoUrl() {
                const url = this.companyDetails && this.companyDetails.logo_url;
                return url ? `/proxy-logo-public?remote_url=${encodeURIComponent(url)}` : null;
            },
        },
        mounted() {
            if (this.orderNumberUrl) {
                this.orderDetailsByOrderNumber(this.orderNumberUrl);
            }
        },
        methods: {
            orderDetailsByOrderNumber(order) {
                axios.get('/api/order-details-customer-view', {
                        params: {
                            order_number: order
                        }
                    })
                    .then(result => {

                        this.orderToShow = result.data.order;
                        this.customer = result.data.customer;
                        this.orderItems = result.data.orderitems;
                        this.companyDetails = result.data.company;
                        this.totalQuantity = this.orderToShow.orders.reduce((accumulator, item) => accumulator + item.qty, 0);
                        // on click scroll back to top
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }
                ).catch(error=>{
                    this.errorResponse = error.response?.data?.error || "Could not load this order. Check your connection and try again."
                    console.log(error)
                });
            },
            formatDate(date, format) {
                let finaldate = moment(date).format(format);
                return finaldate;
            },
            generatePDF() {
                // Get the .invoice element to be converted into PDF
                const element = this.$refs.invoiceElement;
                // Configuration for html2pdf.js
                const opt = {
                    margin: 10,
                    filename: 'invoice.pdf',
                    image: {
                        type: 'jpeg',
                        quality: 0.98
                    },
                    html2canvas: {
                        scale: 2
                    },
                    jsPDF: {
                        unit: 'mm',
                        format: 'a4',
                        orientation: 'portrait'
                    },
                };
                // Generate the PDF using html2pdf.js and trigger the download
                html2pdf().from(element).set(opt).save();
            },
        }
    }
</script>

<style scoped>
    .company-logo-wrap {
        margin-bottom: 0.75rem;
    }
    .company-logo {
        max-height: 120px;
        max-width: 100%;
        width: auto;
        height: auto;
        object-fit: contain;
        border-radius: 6px;
    }
    .powered-by-dukakit {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        color: #6c757d;
        text-decoration: none;
        font-size: 0.85rem;
    }
    .powered-by-dukakit:hover {
        color: #495057;
    }
    .powered-by-dukakit img {
        height: 16px;
        width: auto;
    }
</style>
